import { k8V2ContentfulMappings } from 'utils/product/contentfulMappings'
import { isDwbEnabledAtSite } from 'store/licenseManager/siteProgramAccess'
import { getDigitalWellBeingPreviewPath } from 'utils/digitalWellBeingHelpers'

export { getDigitalWellBeingPreviewPath }

const DWB_PROGRAMS = [
  'elementary',
  'middle-school',
  'high-school',
  'digital-well-being',
]

export const getTier2Slug = link => {
  const source = (link?.slug || link?.title || '')
    .toString()
    .toLowerCase()
    .replace(/[–—]/g, '-')
    .trim()

  if (source.includes('6-8')) return 'grades-6-8'
  if (source.includes('3-5')) return 'grades-3-5'
  if (source.includes('k-2') || source.includes('k2')) return 'grades-k-2'

  // default: ensure plural 'grades-' prefix if starting with 'grade-'
  return source.replace(/^grade-/, 'grades-')
}

const getDefaultUnitSlugForCourse = course =>
  (
    k8V2ContentfulMappings?.find(
      contentfulCourse => contentfulCourse?.id === course?.entryId,
    ) || {}
  ).defaultUnit

export const getTier2PreviewPath = ({ program, course }) =>
  `/product/${program}/lessons/tier-2/preview/${getTier2Slug(
    course,
  )}/${getDefaultUnitSlugForCourse(course)}`

export const isDigitalWellBeingCapabilityEnabledForProgram = ({
  site,
  program,
}) => {
  if (!DWB_PROGRAMS.includes(program)) return false
  if (!site) return false

  return isDwbEnabledAtSite(site)
}

// Converts a tier 2 course title like "Grade 6-8" to display as "Grades 6-8".
// Accepts either a link-like object ({ title, slug }) or a plain string.
export const getTier2DisplayTitle = linkOrTitle => {
  const source = (typeof linkOrTitle === 'string'
    ? linkOrTitle
    : linkOrTitle?.title || linkOrTitle?.slug || ''
  )
    .toString()
    .trim()

  // If title already starts with "Grades", leave it as is
  if (/^\s*grades\b/i.test(source)) return source

  // Pluralize a leading "Grade" (case-insensitive), preserving following separator and content
  return source.replace(/^\s*grade(\s|-)/i, (_match, sep) => `Grades${sep}`)
}

export default {
  getTier2Slug,
  getTier2DisplayTitle,
  getTier2PreviewPath,
  getDigitalWellBeingPreviewPath,
  isDigitalWellBeingCapabilityEnabledForProgram,
}
